<ng-container *transloco="let tloco; prefix: 'subscriptions.billing-info-nav'">
  @if (subscription) {
    <mat-card>
      <div class="flex flex-col md:flex-row">
        <div class="border-b border-steel-20 p-4 md:flex md:w-1/3 md:flex-col md:border-0">
          @if (agencyName) {
            <div class="text-steel-70 text-subheading">{{ agencyName | uppercase }}</div>
          }
          <div
            class="text-heading-2"
            [ngClass]="{
              'mb-2 md:mb-0 md:grow': !(subscription.productUserTypeGrouping !== 'Individual') && (subscription.quantity ?? 0) > 0,
            }"
          >
            {{ profileName }}
          </div>
          @if (subscription.productUserTypeGrouping !== 'Individual' && (subscription.quantity ?? 0) > 0) {
            <div class="mb-2 text-body md:mb-0 md:grow">
              {{
                tloco('team-members', {
                  teamMembers: (agentCount ?? 0) < (subscription.quantity ?? 0) ? (agentCount ?? 0) : (subscription.quantity ?? 0),
                })
              }}
            </div>
          }
        </div>
        <div class="border-b border-steel-20 p-4 md:flex md:w-1/3 md:flex-col md:border-b-0 md:border-l">
          <div class="text-steel-70 text-subheading">{{ subscription.name }}</div>
          @if (!subscription.newPlan) {
            <div class="flex flex-col md:grow">
              <div class="text-body">
                @if (!subscription.isProvided && !subscription.price) {
                  <span class="text-heading-2">$0</span>
                }
                @if (!subscription.isProvided && subscription.price) {
                  <span
                    [innerHtml]="
                      tloco('price.' + subscription.period, {
                        price: subscription.price | prettyCurrency,
                        intervalCount: subscription.periodIntervalCount ?? 1,
                      })
                    "
                  ></span>
                }
                @if (subscription.isProvided) {
                  <span
                    [innerHtml]="
                      tloco('subscriptionProvided', { subscriptionName: subscription.name, providedBy: subscription.providedByProfileName })
                    "
                  ></span>
                }
              </div>
            </div>
          } @else {
            <div class="flex gap-1 md:grow">
              <rma-icon glyph="info" theme="primary" />
              <div
                [innerHTML]="
                  tloco('upcoming-subscription-change', {
                    currentTier: subscription.name,
                    upcomingTier: subscription.newPlan,
                    price: subscription.price | prettyCurrency,
                  })
                "
              ></div>
            </div>
          }
        </div>
        <div class="p-4 md:flex md:w-1/3 md:flex-col md:border-l md:border-steel-20">
          <div class="text-steel-70 text-subheading">{{ subscription.hasCancelled ? tloco('end-billing') : tloco('next-billing') }}</div>
          <div class="mb-2 text-heading-2" [class.md:grow]="!subscription.trialDays">
            {{
              !subscription.isSubscribed && (subscription.trialDays ?? 0) > 0
                ? '~'
                : ((subscription.subscriptionEnd | date: 'MMMM d y') ?? '~')
            }}
          </div>

          @if (subscription.trialDays) {
            <div class="mb-2 rounded-md bg-purple-10 p-3 md:grow">
              {{ tloco('trial-days', { trialDays: subscription.trialDays, subscription: subscription.name }) }}
            </div>
          }

          @if (showBillingLink) {
            <a class="hover:cursor-pointer" routerLink="/manage-account/billing" routerLinkActive="hidden">{{
              tloco('billing-details')
            }}</a>
          }
        </div>
      </div>
    </mat-card>
  }
</ng-container>
